import React, { useState, useEffect } from 'react';
import { FiCopy, FiCheck, FiTag, FiClock, FiStar, FiShield, FiPhone, FiCreditCard, FiArrowRight, FiMail, FiZap, FiGift, FiTrendingUp, FiUsers, FiMapPin } from 'react-icons/fi';
import { MdOutlineFlight, MdOutlineLocalTaxi, MdOutlineCardTravel, MdOutlineBusinessCenter } from 'react-icons/md';
import { BsArrowRepeat, BsStars, BsPersonCheck } from 'react-icons/bs';
import { RiCoupon3Line, RiMotorbikeFill } from 'react-icons/ri';
import offer from "../Assests/Untitled design (11).png"
import { motion } from 'framer-motion';


import { HiOutlineTicket,HiOutlineCheckCircle, HiOutlineClock, HiOutlineTag, HiOutlineLocationMarker } from 'react-icons/hi';
import { BsArrowRightShort } from 'react-icons/bs';

const MobileCard = ({ offer, index }) => {
  // Define gradient backgrounds based on offer type
  const gradients = {
    discount: 'linear-gradient(135deg, #1bb610 0%, #1bb610 100%)',
    coupon: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    special: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    default: 'linear-gradient(135deg, #1bb610 0%, #1bb610 100%)',
  };


  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(offer.code || 'SAVE20');
      setCopied(true);
      
      // Reset after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = offer.code || 'SAVE20';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      whileTap={{ scale: 0.98 }}
      style={{
        background: 'white',
        borderRadius: '28px',
        padding: '20px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
        border: '1px solid rgba(0,0,0,0.03)',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
      }}
    >
      {/* Background decoration */}
      <div style={{
        position: 'absolute',
        top: -20,
        right: -20,
        width: 120,
        height: 120,
        borderRadius: '60px',
        background: offer.gradient || gradients.default,
        opacity: 0.03,
        transform: 'rotate(25deg)',
      }} />
      
      <div style={{ position: 'relative', zIndex: 1 }}>
        {/* Header with icon and type */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          marginBottom: '12px',
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
          }}>
            <div style={{
              background: offer.gradient || gradients.default,
              width: '40px',
              height: '40px',
              borderRadius: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <HiOutlineTicket color="white" size={22} />
            </div>
            <div>
              <span style={{
                fontSize: '13px',
                fontWeight: '600',
                color: '#000000',
                background: '#1bb6107a',
                padding: '4px 10px',
                borderRadius: '30px',
                letterSpacing: '0.3px',
              }}>
                {offer.type || 'PROMO CODE'}
              </span>
            </div>
          </div>
          
          {/* Expiry badge */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            background: '#f3f4f6',
            padding: '6px 10px',
            borderRadius: '30px',
            fontSize: '12px',
            fontWeight: '500',
            color: '#6b7280',
          }}>
            <HiOutlineClock size={14} />
            <span>{offer.expiry || 'Expires soon'}</span>
          </div>
        </div>

        {/* Offer title & description */}
        <h3 style={{
          fontSize: '20px',
          fontWeight: '700',
          color: '#111827',
          margin: '0 0 6px 0',
          lineHeight: 1.3,
        }}>
          {offer.title || 'Special Discount Offer'}
        </h3>
        
        <p style={{
          fontSize: '14px',
          color: '#6b7280',
          margin: '0 0 16px 0',
          lineHeight: 1.5,
        }}>
          {offer.description || 'Get amazing discounts on your next ride with this exclusive promo code'}
        </p>

        {/* Promo code section */}
         <div style={{
        background: '#f9fafb',
        borderRadius: '16px',
        padding: '12px',
        marginBottom: '16px',
        border: `1px dashed ${copied ? '#10b981' : '#e5e7eb'}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        transition: 'border-color 0.3s ease',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <HiOutlineTag color="#e71204" size={18} />
          <span style={{
            fontFamily: 'monospace',
            fontSize: '18px',
            fontWeight: '700',
            color: '#111827',
            letterSpacing: '1px',
          }}>
            {offer.code || 'SAVE20'}
          </span>
        </div>
        
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleCopy}
          style={{
            background: copied ? '#10b981' : 'white',
            border: `1px solid ${copied ? '#10b981' : '#e5e7eb'}`,
            borderRadius: '12px',
            padding: '8px 16px',
            fontSize: '13px',
            fontWeight: '600',
            color: copied ? 'white' : '#e71204',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            transition: 'all 0.3s ease',
          }}
        >
          {copied ? (
            <>
              <HiOutlineCheckCircle size={16} />
              <span>Copied!</span>
            </>
          ) : (
            'Copy'
          )}
        </motion.button>
      </div>

        {/* Footer with location and CTA */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <HiOutlineLocationMarker color="#9ca3af" size={16} />
            <span style={{ fontSize: '13px', color: '#9ca3af' }}>
              {offer.location || 'All cities'}
            </span>
          </div>
          
          <motion.div
            whileHover={{ x: 5 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              color: '#e71204 ',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            <span>View Details</span>
            <BsArrowRightShort size={18} />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

const RED = '#e71204';
const RED2 = '#ff3a1f';
const LIGHT_RED = '#fff5f4';
const BORDER_RED = 'rgba(231,18,4,0.15)';

const offers = [
  {
    id: 1,
    Icon: FiGift,
    tag: 'NEW USER',
    discount: '₹200',
    type: 'FLAT OFF',
    desc: 'On your very first outstation booking with BookinIndia',
    code: 'FIRST200',
    minFare: '₹999',
    maxSave: '₹200',
    validity: 'Mar 31, 2026',
    bg: '#fff5f4',
    border: '#ffc9c4',
    tagBg: '#e71204',
    tagText: '#fff',
    highlight: '#e71204',
  },
  {
    id: 2,
    Icon: MdOutlineFlight,
    tag: 'AIRPORT',
    discount: '₹150',
    type: 'FLAT OFF',
    desc: 'Exclusive savings on all airport pickup & drop rides',
    code: 'FLY150',
    minFare: '₹699',
    maxSave: '₹150',
    validity: 'Apr 15, 2026',
    bg: '#f0f7ff',
    border: '#bdd9ff',
    tagBg: '#2563eb',
    tagText: '#fff',
    highlight: '#2563eb',
  },
  {
    id: 3,
    Icon: BsArrowRepeat,
    tag: 'ROUND TRIP',
    discount: '20%',
    type: 'OFF',
    desc: 'Book both ways and save big on every weekend round trip',
    code: 'WEEKEND20',
    minFare: '₹1,499',
    maxSave: '₹500',
    validity: 'Every Weekend',
    bg: '#f0fdf4',
    border: '#bbf7d0',
    tagBg: '#16a34a',
    tagText: '#fff',
    highlight: '#16a34a',
  },
  {
    id: 4,
    Icon: MdOutlineBusinessCenter,
    tag: 'CORPORATE',
    discount: '15%',
    type: 'OFF',
    desc: 'Special rates for business travellers & corporate teams',
    code: 'CORP15',
    minFare: '₹2,000',
    maxSave: '₹800',
    validity: 'Dec 31, 2026',
    bg: '#fafaf5',
    border: '#e5e0c8',
    tagBg: '#92400e',
    tagText: '#fff',
    highlight: '#92400e',
  },
  {
    id: 5,
    Icon: FiUsers,
    tag: 'REFER & EARN',
    discount: '₹100',
    type: 'EACH',
    desc: 'You save ₹100, your friend saves ₹100 — everyone wins!',
    code: 'REFER100',
    minFare: '₹499',
    maxSave: '₹100',
    validity: 'Ongoing',
    bg: '#fdf4ff',
    border: '#e9b8ff',
    tagBg: '#7c3aed',
    tagText: '#fff',
    highlight: '#7c3aed',
  },
  {
    id: 6,
    Icon: BsStars,
    tag: 'FESTIVE',
    discount: '25%',
    type: 'OFF',
    desc: 'Celebrate every journey with special festive season savings',
    code: 'FEST25',
    minFare: '₹1,299',
    maxSave: '₹650',
    validity: 'Apr 30, 2026',
    bg: '#fffbf0',
    border: '#fde68a',
    tagBg: '#d97706',
    tagText: '#fff',
    highlight: '#d97706',
  },
];

const perks = [
  { Icon: FiShield, label: 'No Cancellation Fee', sub: 'Cancel anytime, free' },
  { Icon: FiPhone, label: '24/7 Support', sub: 'Always here for you' },
  { Icon: FiCreditCard, label: 'Easy Payments', sub: 'UPI, Card, Cash' },
  { Icon: BsPersonCheck, label: 'Verified Drivers', sub: 'Background checked' },
];

const stats = [
  { Icon: FiMapPin, value: '500+', label: 'Cities' },
  { Icon: RiMotorbikeFill, value: '50K+', label: 'Rides' },
  { Icon: FiTrendingUp, value: '₹2Cr+', label: 'User Savings' },
  { Icon: FiStar, value: '4.8★', label: 'Avg Rating' },
];

// ─── COPY BUTTON ──────────────────────────────────────────────────────────────
const CopyBtn = ({ code, highlight }) => {
  const [done, setDone] = useState(false);
  const copy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(code).catch(() => {});
    setDone(true);
    setTimeout(() => setDone(false), 2200);
  };
  return (
    <button onClick={copy} style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      width: '100%',
      background: done ? '#f0fdf4' : '#fff',
      border: `2px dashed ${done ? '#22c55e' : highlight}`,
      borderRadius: '12px', padding: '11px 16px',
      cursor: 'pointer', transition: 'all 0.25s ease', gap: '10px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <RiCoupon3Line style={{ color: done ? '#22c55e' : highlight, fontSize: '18px', flexShrink: 0 }} />
        <span style={{
          fontSize: '16px', fontWeight: 900,
          color: done ? '#22c55e' : '#111827',
          letterSpacing: '3px',
        }}>
          {code}
        </span>
      </div>
      <span style={{
        display: 'flex', alignItems: 'center', gap: '5px',
        fontSize: '12px', fontWeight: 700,
        color: done ? '#22c55e' : highlight,
        background: done ? 'rgba(34,197,94,0.1)' : `rgba(0,0,0,0.05)`,
        padding: '5px 12px', borderRadius: '8px',
        whiteSpace: 'nowrap', transition: 'all 0.2s',
      }}>
        {done ? <><FiCheck size={13} /> Copied!</> : <><FiCopy size={13} /> Copy Code</>}
      </span>
    </button>
  );
};

// ─── DESKTOP CARD ─────────────────────────────────────────────────────────────
// ─── DESKTOP CARD (Enhanced) ─────────────────────────────────────────────────
const DesktopCard = ({ offer, index }) => {
  const { Icon } = offer;
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(offer.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = offer.code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      whileHover={{ y: -5 }}
      style={{
        background: '#fff',
        borderRadius: '28px',
        padding: '24px',
        boxShadow: '0 15px 50px rgba(0,0,0,0.08)',
        border: '1.5px solid rgba(231,18,4,0.08)',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        display: 'flex',
        gap: '24px',
      }}
    >
      {/* Background decoration */}
      <div style={{
        position: 'absolute',
        top: -40,
        right: -40,
        width: 200,
        height: 200,
        borderRadius: '100px',
        background: offer.highlight,
        opacity: 0.03,
        transform: 'rotate(25deg)',
      }} />
      
      {/* Left side - Discount Panel */}
      <div style={{
        width: '220px',
        flexShrink: 0,
        background: offer.bg,
        borderRadius: '20px',
        padding: '28px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        border: `1.5px solid ${offer.border}`,
      }}>
        {/* Notch circles */}
        <div style={{
          position: 'absolute', top: '-12px', right: '-12px',
          width: '24px', height: '24px', borderRadius: '50%',
          background: '#fff', border: '2px solid #e5e7eb',
        }} />
        <div style={{
          position: 'absolute', bottom: '-12px', right: '-12px',
          width: '24px', height: '24px', borderRadius: '50%',
          background: '#fff', border: '2px solid #e5e7eb',
        }} />
        <div style={{
          position: 'absolute', top: '-12px', left: '-12px',
          width: '24px', height: '24px', borderRadius: '50%',
          background: '#fff', border: '2px solid #e5e7eb',
        }} />
        <div style={{
          position: 'absolute', bottom: '-12px', left: '-12px',
          width: '24px', height: '24px', borderRadius: '50%',
          background: '#fff', border: '2px solid #e5e7eb',
        }} />

        {/* <div style={{
          width: '64px', height: '64px', borderRadius: '20px',
          background: offer.highlight,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: '16px',
          boxShadow: `0 8px 20px ${offer.highlight}66`,
        }}>
          <Icon style={{ color: '#fff', fontSize: '30px' }} />
        </div> */}

        <div style={{
          fontSize: '52px', fontWeight: 900,
          color: offer.highlight, lineHeight: 1,
          letterSpacing: '-2px',
        }}>
          {offer.discount}
        </div>
        <div style={{
          fontSize: '14px', fontWeight: 800,
          color: '#6b7280', letterSpacing: '3px',
          marginTop: '4px',
        }}>
          {offer.type}
        </div>

        <span style={{
          marginTop: '16px',
          background: offer.tagBg,
          color: offer.tagText,
          borderRadius: '30px', padding: '6px 16px',
          fontSize: '11px', fontWeight: 800,
          letterSpacing: '1.5px',
        }}>
          {offer.tag}
        </span>
      </div>

      {/* Right side - Content */}
      <div style={{ flex: 1, position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '16px',
        }}>
          <span style={{
            fontSize: '13px',
            fontWeight: '600',
            color: '#000000',
            background: '#1bb6107a',
            padding: '4px 12px',
            borderRadius: '30px',
            letterSpacing: '0.3px',
          }}>
            {offer.tag}
          </span>
          
          {/* Expiry badge */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            background: '#f3f4f6',
            padding: '6px 12px',
            borderRadius: '30px',
            fontSize: '12px',
            fontWeight: '500',
            color: '#6b7280',
          }}>
            <FiClock size={14} />
            <span>{offer.validity}</span>
          </div>
        </div>

        {/* Title & Description */}
        <h3 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          margin: '0 0 8px 0',
          lineHeight: 1.3,
        }}>
          {offer.desc}
        </h3>
        
        <p style={{
          fontSize: '15px',
          color: '#6b7280',
          margin: '0 0 20px 0',
          lineHeight: 1.6,
        }}>
          {offer.desc}
        </p>

        {/* Features */}
        <div style={{
          display: 'flex',
          gap: '12px',
          marginBottom: '24px',
          flexWrap: 'wrap',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: '#f9fafb',
            padding: '8px 16px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
          }}>
            <FiTag size={14} color="#9ca3af" />
            <span style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>
              Min Fare: {offer.minFare}
            </span>
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: '#f9fafb',
            padding: '8px 16px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
          }}>
            <FiZap size={14} color="#9ca3af" />
            <span style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>
              Max Save: {offer.maxSave}
            </span>
          </div>
        </div>

        {/* Promo Code Section */}
        <div style={{
          background: '#f9fafb',
          borderRadius: '16px',
          padding: '16px',
          border: `1px dashed ${copied ? '#10b981' : offer.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'all 0.3s ease',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px', height: '40px',
              borderRadius: '12px',
              background: offer.highlight + '20',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <RiCoupon3Line color={offer.highlight} size={20} />
            </div>
            <span style={{
              fontFamily: 'monospace',
              fontSize: '24px',
              fontWeight: '800',
              color: '#111827',
              letterSpacing: '2px',
            }}>
              {offer.code}
            </span>
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleCopy}
            style={{
              background: copied ? '#10b981' : 'white',
              border: `1px solid ${copied ? '#10b981' : offer.border}`,
              borderRadius: '12px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '600',
              color: copied ? 'white' : offer.highlight,
              cursor: 'pointer',
              boxShadow: '0 4px 8px rgba(0,0,0,0.02)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.3s ease',
            }}
          >
            {copied ? (
              <>
                <FiCheck size={18} />
                <span>Copied!</span>
              </>
            ) : (
              <>
                <FiCopy size={18} />
                <span>Copy Code</span>
              </>
            )}
          </motion.button>
        </div>

        {/* Footer */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: '16px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <FiMapPin color="#9ca3af" size={16} />
            <span style={{ fontSize: '13px', color: '#9ca3af' }}>
              Valid in all cities
            </span>
          </div>
          
          <motion.div
            whileHover={{ x: 5 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              color: offer.highlight,
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            <span>View Details</span>
            <FiArrowRight size={16} />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

// Update the desktop section in the main component:

{/* Offers list - Desktop */}
<div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 24px 72px' }}>
  <div style={{
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', marginBottom: '24px',
  }}>
    <h2 style={{
      fontSize: '22px', fontWeight: 800,
      color: '#111827', margin: 0,
      display: 'flex', alignItems: 'center', gap: '8px',
    }}>
      <FiTag style={{ color: RED }} /> All Offers
    </h2>
    <span style={{
      background: LIGHT_RED, color: RED,
      border: `1px solid ${BORDER_RED}`,
      borderRadius: '20px', padding: '4px 14px',
      fontSize: '12px', fontWeight: 700,
    }}>
      {offers.length} active
    </span>
  </div>

  <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
    {offers.map((offer, i) => (
      <DesktopCard key={offer.id} offer={offer} index={i} />
    ))}
  </div>
</div>

// Update the hero section for desktop:
{/* Hero */}
<div style={{
  background: '#fff',
  borderBottom: '1px solid #e5e7eb',
  padding: '56px 24px 48px',
}}>
  <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
    <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '48px' }}>
      <div style={{ maxWidth: '600px' }}>
        {/* Pill */}
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          background: LIGHT_RED, border: `1px solid ${BORDER_RED}`,
          borderRadius: '30px', padding: '8px 20px',
          fontSize: '13px', fontWeight: 800, color: RED,
          letterSpacing: '1.5px', marginBottom: '24px',
        }}>
          <HiOutlineTicket size={16} /> OFFERS & PROMO CODES
        </div>

        <h1 style={{
          fontSize: '64px', fontWeight: 900,
          color: '#111827', lineHeight: 1.05,
          letterSpacing: '-2.5px', margin: '0 0 20px',
        }}>
          Save on Every<br />
          <span style={{ color: RED }}>BookinIndia</span> Ride
        </h1>

        <p style={{
          fontSize: '18px', color: '#6b7280',
          maxWidth: '520px', lineHeight: 1.65,
          margin: 0, fontWeight: 400,
        }}>
          Handpicked promo codes for outstation trips, airport transfers, corporate travel & more. Copy & go!
        </p>
      </div>

      {/* Stats Grid */}
      <div style={{
        display: 'grid', 
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '16px', 
        flexShrink: 0,
      }}>
        {stats.map((stat, index) => (
          <div key={index} style={{
            background: '#f9fafb',
            borderRadius: '20px',
            padding: '24px 20px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
          }}>
            <stat.Icon style={{ color: RED, fontSize: '28px', marginBottom: '8px' }} />
            <div style={{ fontSize: '28px', fontWeight: 800, color: '#111827' }}>{stat.value}</div>
            <div style={{ fontSize: '14px', color: '#6b7280' }}>{stat.label}</div>
          </div>
        ))}
      </div>
    </div>

    {/* Perks row */}
    <div style={{
      display: 'flex', gap: '0',
      marginTop: '48px',
      background: LIGHT_RED,
      border: `1px solid ${BORDER_RED}`,
      borderRadius: '20px', overflow: 'hidden',
    }}>
      {perks.map(({ Icon, label, sub }, i) => (
        <div key={label} style={{
          flex: 1, display: 'flex', alignItems: 'center', gap: '12px',
          padding: '20px 24px',
          borderRight: i < perks.length - 1 ? `1px solid ${BORDER_RED}` : 'none',
        }}>
          <div style={{
            width: '44px', height: '44px', borderRadius: '12px',
            background: '#fff', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            border: `1px solid ${BORDER_RED}`, flexShrink: 0,
          }}>
            <Icon style={{ color: RED, fontSize: '22px' }} />
          </div>
          <div>
            <div style={{ fontSize: '15px', fontWeight: 700, color: '#111827' }}>{label}</div>
            <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>{sub}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

// ─── MOBILE CARD ──────────────────────────────────────────────────────────────


// ─── MAIN PAGE ────────────────────────────────────────────────────────────────
const OffersPageV3 = () => {
  const [ticker, setTicker] = useState(0);
  const tickerItems = [
    'New users — ₹200 off with FIRST200',
    'Airport rides — flat ₹150 off with FLY150',
    'Round trips this weekend — 20% off with WEEKEND20',
    'Refer a friend — both save ₹100 with REFER100',
    'Festive season — 25% off with FEST25',
  ];
  useEffect(() => {
    const t = setInterval(() => setTicker(p => (p + 1) % tickerItems.length), 3500);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ fontFamily: "'Segoe UI', 'SF Pro Display', -apple-system, sans-serif" }}>

      {/* ══════════════════════ DESKTOP ══════════════════════ */}
      <div className="opv3-desktop">
        <div style={{ background: '#f4f5f9', minHeight: '100vh' }}>

          {/* Ticker bar */}
          <div style={{
            
            background: RED,
            padding: '9px 0',
            textAlign: 'center',
            fontSize: '13px', fontWeight: 700,
            color: '#fff', letterSpacing: '0.3px',
            position: 'sticky', top: 0, zIndex: 50,
          }}>
            <span key={ticker} style={{ animation: 'tickIn 0.4s ease', display: 'inline-block' }}>
              {tickerItems[ticker]}
            </span>
          </div>

          {/* Hero */}
          <div style={{
            marginTop:'-100px',
            background: '#fff',
            borderBottom: '1px solid #e5e7eb',
            padding: '56px 24px 48px',
          }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
              <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '32px' }}>
  <div>
    {/* Pill */}
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: '6px',
      background: LIGHT_RED, border: `1px solid ${BORDER_RED}`,
      borderRadius: '30px', padding: '7px 18px',
      fontSize: '12px', fontWeight: 800, color: RED,
      letterSpacing: '1.5px', marginBottom: '20px',
    }}>
      <HiOutlineTicket size={15} /> OFFERS & PROMO CODES
    </div>

    <h1 style={{
      fontSize: '58px', fontWeight: 900,
      color: '#111827', lineHeight: 1.05,
      letterSpacing: '-2.5px', margin: '0 0 16px',
    }}>
      Save on Every<br />
      <span style={{ color: RED }}>BookinIndia</span> Ride
    </h1>

    <p style={{
      fontSize: '17px', color: '#6b7280',
      maxWidth: '460px', lineHeight: 1.65,
      margin: 0, fontWeight: 400,
    }}>
      Handpicked promo codes for outstation trips, airport transfers, corporate travel & more. Copy & go!
    </p>
  </div>

  {/* Stats section - if you want multiple stats/images */}
  <div style={{
  position: 'relative',
  overflow: 'hidden',
  height: '400px',
  width: '100%',
  borderRadius: '20px',
}}>
  {/* Road background effect */}
  <div style={{
    position: 'absolute',
    bottom: '30%',
    width: '100%',
    height: '2px',
    background: 'linear-gradient(90deg, transparent, #e71204 20%, #e71204 80%, transparent)',
    opacity: 0.3,
  }} />
  
  {/* Lane markers */}
  <div style={{
    position: 'absolute',
    bottom: '30%',
    width: '100%',
    height: '1px',
    background: 'repeating-linear-gradient(90deg, #e71204, #e71204 20px, transparent 20px, transparent 40px)',
    opacity: 0.2,
  }} />

  {/* Speed lines for motion effect */}
  <motion.div
    animate={{
      x: [0, -100],
      opacity: [0, 0.5, 0],
    }}
    transition={{
      duration: 1,
      repeat: Infinity,
      ease: "linear",
    }}
    style={{
      position: 'absolute',
      top: '40%',
      right: '10%',
      width: '100px',
      height: '2px',
      background: 'linear-gradient(90deg, transparent, white, transparent)',
      filter: 'blur(2px)',
    }}
  />

  {/* Main car with realistic animation */}
  <motion.img
    src={offer}
    alt='Moving car'
    className='w-auto h-96 mt-10'
    animate={{
      x: [1200, -400], // Start off-screen right, end off-screen left
      y: [0, -5, 3, -2, 0], // Subtle bounce for realism
      rotate: [0, 0.3, -0.2, 0.1, 0], // Slight tilt for weight transfer
      scale: [1, 1.02, 0.98, 1.01, 1], // Subtle scale for depth
    }}
    transition={{
      x: {
        duration: 8,
        repeat: Infinity,
        ease: "linear",
        repeatType: "loop",
      },
      y: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
        times: [0, 0.25, 0.5, 0.75, 1],
      },
      rotate: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
      },
      scale: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
      }
    }}
    style={{
      position: 'relative',
      filter: 'drop-shadow(0 20px 13px rgba(0,0,0,0.25))',
      zIndex: 10,
    }}
  />

  {/* Motion blur effect */}
  <motion.div
    animate={{
      x: [1200, -400],
    }}
    transition={{
      duration: 8,
      repeat: Infinity,
      ease: "linear",
      repeatType: "loop",
    }}
    style={{
      position: 'absolute',
      top: '35%',
      width: '200px',
      height: '100px',
      background: 'radial-gradient(circle, rgba(231,18,4,0.1) 0%, transparent 70%)',
      filter: 'blur(20px)',
      pointerEvents: 'none',
    }}
  />
</div>
</div>

              {/* Perks row */}
              <div style={{
                display: 'flex', gap: '0',
                marginTop: '40px',
                background: LIGHT_RED,
                border: `1px solid ${BORDER_RED}`,
                borderRadius: '16px', overflow: 'hidden',
              }}>
                {perks.map(({ Icon, label, sub }, i) => (
                  <div key={label} style={{
                    flex: 1, display: 'flex', alignItems: 'center', gap: '12px',
                    padding: '16px 20px',
                    borderRight: i < perks.length - 1 ? `1px solid ${BORDER_RED}` : 'none',
                  }}>
                    <div style={{
                      width: '38px', height: '38px', borderRadius: '10px',
                      background: '#fff', display: 'flex',
                      alignItems: 'center', justifyContent: 'center',
                      border: `1px solid ${BORDER_RED}`, flexShrink: 0,
                    }}>
                      <Icon style={{ color: RED, fontSize: '18px' }} />
                    </div>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: 700, color: '#111827' }}>{label}</div>
                      <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '1px' }}>{sub}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Offers list */}
          <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 24px 72px' }}>
            <div style={{
              display: 'flex', alignItems: 'center',
              justifyContent: 'space-between', marginBottom: '24px',
            }}>
              <h2 style={{
                fontSize: '22px', fontWeight: 800,
                color: '#111827', margin: 0,
                display: 'flex', alignItems: 'center', gap: '8px',
              }}>
                <FiTag style={{ color: RED }} /> All Offers
              </h2>
              <span style={{
                background: LIGHT_RED, color: RED,
                border: `1px solid ${BORDER_RED}`,
                borderRadius: '20px', padding: '4px 14px',
                fontSize: '12px', fontWeight: 700,
              }}>
                {offers.length} active
              </span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {offers.map((offer, i) => (
                <DesktopCard key={offer.id} offer={offer} index={i} />
              ))}
            </div>

            {/* Email CTA */}
            <div style={{
              marginTop: '48px',
              background: '#fff',
              border: `1.5px solid ${BORDER_RED}`,
              borderRadius: '24px',
              padding: '40px 48px',
              display: 'flex', alignItems: 'center',
              gap: '40px',
              boxShadow: '0 4px 20px rgba(231,18,4,0.07)',
            }}>
              <div style={{
                width: '60px', height: '60px', borderRadius: '18px',
                background: LIGHT_RED, display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                border: `1.5px solid ${BORDER_RED}`, flexShrink: 0,
              }}>
                <FiMail style={{ color: RED, fontSize: '26px' }} />
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '20px', fontWeight: 800, color: '#111827', margin: '0 0 6px' }}>
                  Get exclusive offers in your inbox
                </h3>
                <p style={{ fontSize: '14px', color: '#9ca3af', margin: 0 }}>
                  Join 50,000+ BookinIndia users who never miss a deal.
                </p>
              </div>
              <div style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  style={{
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '12px', padding: '13px 18px',
                    fontSize: '14px', outline: 'none',
                    color: '#111827', background: '#fafafa',
                    width: '230px',
                  }}
                />
                <button style={{
                  background: `linear-gradient(135deg, ${RED}, ${RED2})`,
                  color: '#fff', border: 'none',
                  borderRadius: '12px', padding: '13px 24px',
                  fontSize: '14px', fontWeight: 700, cursor: 'pointer',
                  boxShadow: `0 4px 16px rgba(231,18,4,0.35)`,
                  display: 'flex', alignItems: 'center', gap: '6px',
                  whiteSpace: 'nowrap',
                }}>
                  Subscribe <FiArrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════ MOBILE ══════════════════════ */}
      <div className="opv3-mobile">
        <div style={{
          background: '#f4f5f9',
          minHeight: '100vh',
          maxWidth: '430px',
          margin: '0 auto',
          fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
        }}>

          {/* App Header */}
          <div style={{
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
            padding: '52px 18px 20px',
            marginTop:'-110px',
          }}>
            {/* Pill */}
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              background: LIGHT_RED, border: `1px solid ${BORDER_RED}`,
              borderRadius: '20px', padding: '5px 14px',
              fontSize: '11px', fontWeight: 800, color: RED,
              letterSpacing: '1px', marginBottom: '12px',
            }}>
              <HiOutlineTicket size={13} /> OFFERS & PROMO CODES
            </div>

            <h1 style={{
              fontSize: '28px', fontWeight: 900,
              color: '#111827', letterSpacing: '-0.8px',
              lineHeight: 1.15, margin: '0 0 8px',
            }}>
              Save on Every<br />
              <span style={{ color: RED }}>BookinIndia</span> Ride
            </h1>
            <p style={{
              fontSize: '13px', color: '#9ca3af',
              margin: '0 0 18px', lineHeight: 1.5,
            }}>
              Copy a code and ride for less. {offers.length} active deals right now.
            </p>

            {/* Stats row */}
         <div style={{
  display: 'grid', 
  gridTemplateColumns: '1fr 1fr',
  gap: '0px', 
  flexShrink: 0,
  marginBottom: '10px',
  position: 'relative',
  overflow: 'hidden',
  height: '400px',
}}>
  <motion.img
    src={offer}
    alt='offer 1'
    className='w-auto h-98 -mt-20'
    animate={{
      x: [600, -200], // From right to left
    }}
    transition={{
      duration: 4,
      repeat: Infinity,
      ease: "linear",
      repeatType: "loop",
    }}
    style={{
      position: 'relative',
      filter: 'drop-shadow(0 20px 13px rgba(0,0,0,0.15))',
    }}
  />
</div>
          </div>

          {/* Red ticker */}
          <div style={{
            background: RED,
            padding: '9px 18px',
            fontSize: '12px', fontWeight: 700, color: '#fff',
            letterSpacing: '0.3px', overflow: 'hidden',
            marginTop:'-380px',
          }}>
            <span key={ticker} style={{ animation: 'tickIn 0.4s ease', display: 'inline-block' }}>
              {tickerItems[ticker]}
            </span>
          </div>

          {/* Perks horizontal scroll */}
          <div style={{ padding: '14px 0 0', overflowX: 'auto' }}>
            <div style={{ display: 'flex', gap: '10px', padding: '0 18px 4px', width: 'max-content' }}>
              {perks.map(({ Icon, label, sub }) => (
                <div key={label} style={{
                  background: '#fff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '14px', padding: '12px 14px',
                  minWidth: '120px', display: 'flex',
                  flexDirection: 'column', alignItems: 'center', gap: '6px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}>
                  <div style={{
                    width: '34px', height: '34px', borderRadius: '10px',
                    background: LIGHT_RED, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                  }}>
                    <Icon style={{ color: RED, fontSize: '17px' }} />
                  </div>
                  <div style={{ fontSize: '11px', fontWeight: 700, color: '#111827', textAlign: 'center', lineHeight: 1.3 }}>{label}</div>
                  <div style={{ fontSize: '10px', color: '#9ca3af', textAlign: 'center' }}>{sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Section header */}
          <div style={{
            padding: '20px 18px 10px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <span style={{
              fontSize: '17px', fontWeight: 800, color: '#111827',
              display: 'flex', alignItems: 'center', gap: '6px',
            }}>
              <FiTag style={{ color: RED }} /> All Offers
            </span>
            <span style={{
              background: LIGHT_RED, color: RED,
              border: `1px solid ${BORDER_RED}`,
              borderRadius: '20px', padding: '3px 12px',
              fontSize: '11px', fontWeight: 700,
            }}>
              {offers.length} active
            </span>
          </div>

          {/* Cards */}
          <div style={{ padding: '4px 18px 110px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {offers.map((offer, i) => (
              <MobileCard key={offer.id} offer={offer} index={i} />
            ))}
          </div>

          {/* Fixed bottom CTA */}
          <div style={{
            position: 'fixed', bottom: 0,
            left: '50%', transform: 'translateX(-50%)',
            width: '100%', maxWidth: '430px',
            padding: '12px 18px 28px',
            background: 'rgba(255,255,255,0.97)',
            backdropFilter: 'blur(12px)',
            borderTop: '1px solid #f0f0f0',
            zIndex: 200,
          }}>
            <button style={{
              width: '100%',
              background: `linear-gradient(135deg, ${RED} 0%, ${RED2} 100%)`,
              color: '#fff', border: 'none',
              borderRadius: '16px', padding: '16px',
              fontSize: '15px', fontWeight: 800,
              cursor: 'pointer',
              boxShadow: `0 6px 20px rgba(231,18,4,0.35)`,
              display: 'flex', alignItems: 'center',
              justifyContent: 'center', gap: '8px',
            }}>
              <MdOutlineLocalTaxi style={{ fontSize: '20px' }} />
              Book a Cab Now
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .opv3-desktop { display: block; }
        .opv3-mobile  { display: none;  }

        @media (max-width: 767px) {
          .opv3-desktop { display: none !important;  }
          .opv3-mobile  { display: block !important; }
        }

        @keyframes cardIn {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0);    }
        }

        @keyframes tickIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0);   }
        }

        input::placeholder { color: #9ca3af; }
        ::-webkit-scrollbar { height: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 4px; }
      `}</style>
    </div>
  );
};

export default OffersPageV3;